module.exports = __webpack_public_path__ + "static/media/blueVert.e5760fba.png";